import React from 'react'
import { graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import {
  // TeamSectionContainer, 
  PageSection, 
  // AboutUs, 
  CallToAction, 
  Footer, 
  Hero,
  Navbar,
  Investors,
  Academy,
  Recognition,
  VideoSection,
  SocialBar
} from '../components/'
//@ts-ignore
import styles from './index.module.css'
import { Pricing } from '../components/Pricing/Pricing'

const RootIndex: React.FunctionComponent<{props: any}> = (props) => {
    // @ts-ignore
    const {
      site, 
      allContentfulPerson: people, 
      allContentfulPageSection: sections,
      contentfulTargetedText: heroText,
      contentfulLink: buttonData
    } = props.data;
    // console.log({sections})

    return(
        <div className={styles.pageContainer}>  
            <Helmet>
              <title>{site.siteMetadata.title}</title>
            </Helmet>
            <Navbar buttonData={buttonData}/>
            <SocialBar />
            <Hero text={heroText} buttonData={buttonData}/>
            {
              sections.edges.map((node, _) => {
                return <PageSection section={{...node.node}} key={_} index={_}/>
              })
            }
            <VideoSection/>
            <Pricing />
            {/* <AboutUs /> */}
            <Academy />
            <Recognition />
            <Investors />
            <CallToAction buttonData={buttonData}/>
            <Footer />
            {/* <TeamSectionContainer people={people.edges}/> */}
        </div>
    )
}

export default RootIndex;

export const pageQuery = graphql`
query SiteMeta {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulPerson {
        edges {
          node {
            name
            title
            linkedIn
            image {
              fluid {
                src
              }
            }
          }
        }
    }
    allContentfulPageSection(sort:{
      fields: [serialNumber],
      order:ASC
    }, filter: {forSalesWebsiteOnly: {ne: true}} ){
      edges {
        node {
          sectionImages {
            file {
              url
            }
          }
          titleText
          textContent {
            childMarkdownRemark {
              html
            }
          }
          isDesktop
        }
      }
    }

    contentfulTargetedText(name: {eq: "hero text"}){
      name
      content {
        content
      }
    }

    contentfulLink(buttonText: {eq: "Book A Demo"}){
      url
      buttonText
    }
}

`